import { createContext } from 'react';

export type ReceptionistsContext = {
  isLoading: boolean;
  isFetched: boolean;
  receptionists: string[];
  activeReceptionist: string | null;
  setActiveReceptionist: (_receptionist: string | null) => void;
};

export const receptionistsContext = createContext<ReceptionistsContext>(undefined as unknown as ReceptionistsContext);
